import {
  MobilePageHeader,
  MobileModalContent,
  Button,
} from "../../../components";
import { Container, Row, Col } from "react-grid-system";
import React from "react";
import { useDispatch } from "react-redux";
import { setModalContent, setModalVisible } from "../../../store/modal/actions";
import { useTranslation } from "react-i18next";

import { logout } from "../../../store/app/actions";

export default function ApproveLogout() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onCancelClick = () => {
    dispatch(setModalVisible(false));
    dispatch(setModalContent(null));
  };

  const onSubmitClick = () => {
    dispatch(logout());
    window.location.reload();
  };

  return (
    <Container>
      <MobileModalContent height={"100%"}>
        <Row>
          <Col xs={12}>
            <MobilePageHeader>
              {t("views.modals.approve_logout.header")}
            </MobilePageHeader>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button
              role={"secondary"}
              display={"block"}
              onClick={onSubmitClick}
            >
              {t("views.modals.approve_logout.btn_yes")}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button role={"primary"} display={"block"} onClick={onCancelClick}>
              {t("views.modals.approve_logout.btn_no")}
            </Button>
          </Col>
        </Row>
      </MobileModalContent>
    </Container>
  );
}
